import { Box, Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

interface Props {
  onClick: () => void;
}

const EditButton = ({ onClick }: Props) => {
  return (
    <Box>
      <Button
        className="edit-button"
        onClick={() => {
          onClick();
          const element = document.getElementById("scrollTarget");
          if (element) {
            element.scrollIntoView({
              behavior: "auto",
            });
          }
        }}
        startIcon={
          <EditOutlinedIcon fontSize="small" sx={{ marginRight: 0 }} />
        }
      >
        Redigera
      </Button>
    </Box>
  );
};

export default EditButton;
